<template lang="pug">
#dashboard-monitoramento-operacao
    BaseHeader(
        :titulo='$t("mensagens.operacao.dashboard.monitoramentos")',
        :exibeBotao='false',
        :exibeBotaoSecundarioAcao='false'
    )
    .view-container-base-header
        h2 {{ $t('mensagens.operacao.monitoramento.monitoramentoBaseDados') }}
        section.lista-base-dados__tabela(v-loading='carregandoTabelaBaseDados')
            el-table(
                :data='baseDados.camadas',
                stripe,
                height='100%',
                @sort-change='ordenarBaseDados'
            )
                el-table-column.coluna__tabela(
                    label='Base de dados',
                    align='center',
                    sortable
                )
                    template(slot-scope='scope')
                        span.centered-content {{ scope.row.nome }}

                el-table-column.coluna__tabela(
                    label='Última atualização',
                    align='center',
                    sortable
                )
                    template(slot-scope='scope')
                        span.centered-content {{ scope.row.dataFonteDados }}
            .tabela-rodape
                .tabela-rodape--esquerda
                    p {{ baseDados.total }} {{ $t('mensagens.operacao.monitoramento.registros') }}

        //-
            h2 {{ $t('mensagens.operacao.monitoramento.monitoramentoDeOperacao') }}
            section.dashboard-monitoramento-operacao__barra-pesquisa
                el-date-picker(
                    v-model='dataInicio',
                    type='date',
                    placeholder='Data início',
                    format='dd/MM/yyyy'
                )
                el-date-picker(
                    v-model='dataFim',
                    type='date',
                    placeholder='Data fim',
                    format='dd/MM/yyyy'
                )
                el-select(v-model='filtro.status', clearable, filterable)
                    el-option(
                        v-for='{ label, value } in opcoes',
                        :key='value + label',
                        :label='label',
                        :value='value'
                    )
                .form-aplicar-filtros
                    BaseButton(@click='limparFiltros') {{ $t('mensagens.blocoFiltros.uteis.limparFiltro') }}
                    BaseButton(type='primary', @click='aplicarFiltros') {{ $t('mensagens.blocoFiltros.uteis.aplicarFiltros') }}

            section.dashboard-monitoramento-operacao__tabela(v-loading='carregandoTabela')
                el-table(
                    :data='monitoramentos',
                    stripe,
                    height='100%',
                    @sort-change='ordenar'
                )
                    el-table-column(
                        :label='$t("mensagens.operacao.dashboard.dataMonitoramento")',
                        align='center',
                        sortable
                    )
                        template(slot-scope='scope')
                            span {{ scope.row.dataMonitoramento }}

                    el-table-column(
                        :label='$t("mensagens.operacao.titulo")',
                        sortable
                    )
                        template(slot-scope='scope')
                            span {{ scope.row.quantidadeOperacao }}
                    el-table-column(label='Pessoas', sortable)
                        template(slot-scope='scope')
                            span {{ scope.row.quantidadePessoa }}
                    el-table-column(label='Territórios', sortable)
                        template(slot-scope='scope')
                            span {{ scope.row.quantidadeTerritorio }}
                    el-table-column(label='Status', sortable)
                        template(slot-scope='scope')
                            span {{ $t(`mensagens.operacao.dashboard.${scope.row.statusOperacao.codigo}`) }}
                    el-table-column
                        template(slot-scope='scope')
                            BaseButton(@click='visualizar(scope.row)') {{ $t('mensagens.operacao.acoes.visualizar') }}

                .tabela-rodape
                    .tabela-rodape--esquerda
                        p {{ paginacao.total }} {{ $t('mensagens.operacao.dashboard.monitoramentosMinusculo') }}
                    .tabela-rodape--pagination
                        el-pagination(
                            small,
                            layout='prev, pager, next',
                            :page-size='paginacao.itensPorPagina',
                            :current-page.sync='paginacao.pagina',
                            :total='paginacao.total',
                            @current-change='buscarMonitoramentos(paginacao.pagina - 1)'
                        )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import OperacaoDashboardMonitoramentoService from '@/services/OperacaoDashboardMonitoramentoService';
// import BaseButton from '@/components/vegaComponents/BaseButton';

export default {
    name: 'DashboardMonitoramentoOperacao',

    components: {
        BaseHeader
        // BaseButton
    },

    data() {
        return {
            // monitoramentos: [],
            // carregandoTabela: false,
            baseDados: [],
            ordenacaoBaseDados: {
                direcao: 'ascending',
                ordernarPor: 'nome'
            },
            carregandoTabelaBaseDados: false
            // dataInicio: null,
            // dataFim: null,
            // opcoes: [
                // {
                    // value: 'REALIZADO',
                    // label: this.$t('mensagens.operacao.dashboard.realizado')
                // },
                // {
                    // value: 'NAO_REALIZADO',
                    // label: this.$t('mensagens.operacao.dashboard.naoRealizado')
                // },
                // {
                    // value: 'REALIZADO_COM_ERRO_PESSOA_TERRITORIO',
                    // label: this.$t(
                        // 'mensagens.operacao.dashboard.realizadoComErro'
                    // )
                // }
            // ],
            // paginacao: {
                // direcao: null,
                // itensPorPagina: 20,
                // ordernarPor: null,
                // pagina: 0,
                // totalPaginas: 0,
                // total: 0
            // },
            // filtro: {
                // dataInicio: null,
                // dataFim: null,
                // status: null
            // }
        };
    },

    mounted() {
        // this.montaDataFiltro();
        // this.aplicarFiltros();
        this.tabelaBaseDados();
    },

    methods: {
        // montaDataFiltro() {
            // var date = new Date();
            // date.setDate(date.getDate() - 30);

            // this.dataInicio = date;
            // this.dataFim = new Date();
        // },

        // aplicarFiltros() {
            // if (this.dataInicio) {
                // this.filtro.dataInicio = new Date(
                    // this.dataInicio
                // ).toLocaleDateString('pt-BR');
            // }
            // if (this.dataFim) {
                // this.filtro.dataFim = new Date(this.dataFim).toLocaleDateString(
                    // 'pt-BR'
                // );
            // }
            // if (this.filtro.status === '') {
                // this.filtro.status = null;
            // }

            // this.buscarMonitoramentos();
        // },

        // limparFiltros() {
            // this.filtro.dataInicio = null;
            // this.filtro.dataFim = null;
            // this.filtro.status = null;
            // this.montaDataFiltro();
            // this.aplicarFiltros();
        // },

        // ordenar(props) {
            // this.paginacao.direcao = props.order;
            // this.paginacao.ordernarPor = props.column.label;

            // if (props.order === null) this.paginacao.ordernarPor = null;
            // this.buscarMonitoramentos();
        // },

        // async buscarMonitoramentos(pagina) {
            // this.carregandoTabela = true;
            // this.paginacao.pagina = pagina;
            // const direcao =
                // this.paginacao.direcao &&
                // this.paginacao.direcao.includes('ascending')
                    // ? 'ASC'
                    // : 'DESC';

            // await OperacaoDashboardMonitoramentoService.buscarHistoricos({
                // ...this.filtro,
                // paginacao: { ...this.paginacao, direcao: direcao }
            // })
                // .then(({ data }) => {
                    // this.monitoramentos = data.itens;

                    // this.paginacao.pagina = data.paginacao.pagina + 1;
                    // this.paginacao.total = data.paginacao.total;
                    // this.paginacao.itensPorPagina =
                        // data.paginacao.itensPorPagina;
                    // this.paginacao.totalPaginas = data.paginacao.totalPaginas;
                // })
                // .catch();
            // this.carregandoTabela = false;
        // },

        ordenarBaseDados(props) {
            this.ordenacaoBaseDados.direcao = props.order;
            this.ordenacaoBaseDados.ordernarPor = props.column.label;

            if (props.order === null) {
                this.ordenacaoBaseDados.ordernarPor = 'nome';
            }
            this.tabelaBaseDados();
        },

        async tabelaBaseDados() {
            try {
                this.carregandoTabelaBaseDados = true;
                const ordem = {
                    direcao:
                        this.ordenacaoBaseDados.direcao &&
                        this.ordenacaoBaseDados.direcao.includes('descending')
                            ? 'DESC'
                            : 'ASC',
                    ordernarPor:
                        this.ordenacaoBaseDados.ordernarPor &&
                        this.ordenacaoBaseDados.ordernarPor.includes(
                            'Última atualização'
                        )
                            ? 'ultimaAtualizacao'
                            : 'nome'
                };

                const { data } =
                    await OperacaoDashboardMonitoramentoService.buscarTabelaBaseDados(
                        { ...ordem }
                    );
                this.baseDados = data;
            } finally {
                this.carregandoTabelaBaseDados = false;
            }
        }

        // visualizar(row) {
            // this.$router.push({
                // name: 'relatorioMonitoramentoOperacaoTerritorios',
                // params: { historico: row }
            // });
        // }
    }
};
</script>

<style lang="scss">
#dashboard-monitoramento-operacao {
    h2 {
        min-height: 42px;
    }
    .lista-base-dados__tabela,
    .dashboard-monitoramento-operacao__tabela {
        height: calc(100vh - 100px);
    }
    .lista-base-dados__tabela {
        margin-bottom: 7rem !important;
    }

    .centered-content {
        display: block;
        text-align: center;
        width: 100%;
    }

    .coluna__tabela {
        text-align: center;
    }

    .dashboard-monitoramento-operacao__barra-pesquisa {
        display: flex;
        justify-content: flex-start;
        gap: 2%;
        padding-left: 2%;
        height: 5vw;
        align-items: center;

        background-color: var(--white);
        margin-bottom: 1rem;
    }

    .tabela-rodape {
        height: 54px;
        background: var(--white);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 44% 10px 5px;
        margin-top: 8px;
        border-radius: 5px;

        .tabela-rodape--esquerda p {
            margin-bottom: 0;
            color: var(--primary);
            margin-left: 10px;
        }

        .tabela-rodape--pagination {
            .el-pager li.active {
                color: var(--white);
                font-weight: 900;
                background: var(--primary);
            }

            .el-pager li {
                padding: 0 4px;
                background: var(--white);
                vertical-align: top;
                display: inline-block;
                font-size: 13px !important;
                min-width: 28px !important;
                height: 28px !important;
                line-height: 28px !important;
                box-sizing: border-box;
                text-align: center;
                margin: 0;
                border-radius: 2px;
                color: var(--primary);
            }

            .el-pagination button {
                height: 28px;
            }
        }
    }
}
</style>
